module.exports = __webpack_public_path__ + "img/logo 4.c8b5c37f.jpg";